export default (input, decimals) => {
  const value = parseFloat(input * 100);
  return `${value.toFixed(decimals)}%`;
};
